import { USERS, LOADING } from './PermissionsActions';

const INITIAL_STATE = {
  loading: false,
  users: [],
  page: 0,
  total: 0,
};

const PermissionsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case USERS: {
      return {
        ...state,
        loading: false,
        users: action.data.results,
        page: action.data.page,
        total: action.data.total,
      };
    }
    case LOADING: {
      return {
        ...state,
        loading: action.val,
      };
    }
  }

  return state;
};

export default PermissionsReducer;
